export const heading = ['S.No', 'Prefix', 'Start Number', 'Suffix', 'Taxability', 'Preview', 'Action'];
export const addNewSetting = {
  prefix: '',
  nextinvoicenumber: '',
  suffix: '',
  taxability: '',
};

export const isDefaultVoucherSeries = (series) => Number(series?.restrictedflag) === 1;

export const getTaxabilityForUpdate = (series, selectedTaxability) =>
  isDefaultVoucherSeries(series) ? Number(series?.taxability || 0) : Number(selectedTaxability || 0);

export const isUsedVoucherSeries = (series) => Number(series?.serialisused) === 1;

export const hasStartNumberChange = (original, updated) =>
  String(original?.nextinvoicenumber ?? '') !== String(updated?.nextinvoicenumber ?? '');

export const hasNonStartNumberChanges = (original, updated) =>
  (original?.prefix ?? '') !== (updated?.prefix ?? '') ||
  (original?.suffix ?? '') !== (updated?.suffix ?? '') ||
  Number(original?.taxability ?? 0) !== Number(updated?.taxability ?? 0);

export const START_NUMBER_CHANGE_WARNING = {
  title: 'Warning',
  heading: 'Change Start Number?',
  description:
    'Changing the Start Number may affect the continuity of this voucher series. This could have statutory implications depending on applicable GST laws and regulations. The updated Start Number will be used only for future vouchers; existing voucher numbers will remain unchanged. Do you want to continue?',
  continueLabel: 'Continue',
  cancelLabel: 'Cancel',
};

export const USED_SERIES_MODIFY_BLOCKED_MESSAGE =
  'This voucher series is already used in transactions and cannot be modified or deleted.';
